import { getCupStatus } from "./deviceStatusDisplay";

// Askı sensörü — son okumaları dosya olarak indirme (Bakım sekmesi).
// Sahada "kol yukarıdayken neden yerinde değil dedi" sorusu tek bir canlı
// değerden okunamıyor; son N okumanın dökümü servise/geliştiriciye iletilir.
// Liste useHangerSensorLive'da tutulur, burada yalnız CSV üretilir.

export const HANGER_HISTORY_LIMIT = 50;

// Tabletteki renk kuralinin aynisi (HangerSensorDrawer valueQuality).
// Beklenen konum ana ekran durumundan: 0 = Hazir (kol yukarida),
// 21 = Pisirici Asagida (kol asagida).
export const valueQuality = (live) => {
  const dev = live?.dev;
  const flat = live?.flat;
  if (!Number.isFinite(dev) || !Number.isFinite(flat)) return null;
  const inPlace = dev < 7 && flat > 243; // kartin karar kurali
  const solidUp = dev <= 2 && flat >= 248;
  const solidDown = dev >= 30;
  const expected =
    live.brewing === 21 ? "down" : live.brewing === 0 ? "up" : null;
  if (expected === "up") {
    if (!inPlace) return "bad";
    return solidUp ? "good" : "warn";
  }
  if (expected === "down") {
    if (inPlace) return "bad";
    return solidDown ? "good" : "warn";
  }
  if (inPlace) return solidUp ? "good" : "warn";
  return solidDown ? "good" : "warn";
};

export const QUALITY_TEXT = {
  good: "Beklenen konumla uyumlu",
  warn: "Karar sınırına yakın",
  bad: "Beklenen konumla uyuşmuyor",
};

// Değerlendirme rengi (canlı değer satırları + açıklama paneli rozeti).
export const QUALITY_STYLE = {
  good: "bg-emerald-50 border-emerald-300 text-emerald-700",
  warn: "bg-amber-50 border-amber-300 text-amber-700",
  bad: "bg-rose-50 border-rose-300 text-rose-700",
};

export const expectedText = (brewing) =>
  brewing === 0
    ? "Kol yukarıda olmalı (Hazır)"
    : brewing === 21
      ? "Kol aşağıda olmalı (Pişirici Aşağıda)"
      : "İşlem sürüyor — beklenen konum yok";

export const stateText = (state) =>
  state === 0 ? "Yerinde" : state === 1 ? "Yerinde değil" : "Karttan veri yok";

const SOURCE_TEXT = { drawer: "Makine ekranı", remote: "Panel" };

const pad = (n, w = 2) => String(n).padStart(w, "0");

// Yerel saat, milisaniyeli — Excel'de sıralanabilir.
const formatTime = (value) => {
  if (value == null) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.` +
    pad(d.getMilliseconds(), 3)
  );
};

// Türkçe Excel ayırıcısı ";" — hücrede ; " ya da satır sonu varsa tırnakla.
const cell = (v) => {
  const s = v === null || v === undefined ? "" : String(v);
  return /[;"\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const COLUMNS = [
  ["Sıra", (e, i) => i + 1],
  ["Panel zamanı", (e) => formatTime(e.receivedAt)],
  ["Makine zamanı", (e) => formatTime(e.data.ts)],
  ["Göz", (e) => e.data.cup],
  ["Kaynak", (e) => SOURCE_TEXT[e.data.source] || e.data.source],
  ["Sensör durumu", (e) => stateText(e.data.state)],
  ["Ortalama seviye", (e) => e.data.level],
  ["Sapan örnek", (e) => e.data.dev],
  ["Düz örnek", (e) => e.data.flat],
  // Eski kart seti askısı (v0.4.6+) fark yöntemiyle ölçer (WS#398).
  ["Fark", (e) => e.data.diff],
  ["Fark eşiği", (e) => e.data.diffThreshold],
  ["Değerlendirme", (e) => QUALITY_TEXT[valueQuality(e.data)] || ""],
  ["Hassasiyet", (e) => e.data.sensitivity],
  ["Göz durum kodu", (e) => e.data.brewing],
  [
    "Göz durumu",
    (e) =>
      Number.isFinite(e.data.brewing) ? getCupStatus(e.data.brewing).label : "",
  ],
  ["Veri yaşı (ms)", (e) => e.data.ageMs],
];

/**
 * @param {{ receivedAt: number, data: object }[]} entries eskiden yeniye
 * @returns {string} UTF-8 BOM'lu, ";" ayırıcılı CSV
 */
export function buildHangerHistoryCsv(entries) {
  const lines = [COLUMNS.map(([h]) => cell(h)).join(";")];
  entries.forEach((e, i) => {
    lines.push(COLUMNS.map(([, get]) => cell(get(e, i))).join(";"));
  });
  // BOM: Excel UTF-8'i tanısın (Türkçe karakterler bozulmasın).
  return `﻿${lines.join("\r\n")}\r\n`;
}

export function hangerHistoryFileName(serialNo, now = new Date()) {
  const stamp =
    `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}-` +
    `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
  const sn = String(serialNo || "cihaz").replace(/[^\w-]+/g, "_");
  return `aski-sensoru_${sn}_${stamp}.csv`;
}

export function downloadHangerHistory(entries, serialNo) {
  const blob = new Blob([buildHangerHistoryCsv(entries)], {
    type: "text/csv;charset=utf-8",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = hangerHistoryFileName(serialNo);
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
